<template>
	<div class="photo-uploader">
		<div class="uploader-title" v-if="title">
			{{ title }}
		</div>
		<div class="uploader-content">
			<div class="uploader-item">
				<div class="cropper-box">
					<img v-if="photoImage" :src="photoImage" class="preview-img"/>
					<h5-cropper 
						v-show="!photoImage"
						:option="cropOptions"
						@getbase64="handlePhotoCrop"
					></h5-cropper>
					<div v-if="!photoImage" class="upload-tip">
						<van-icon name="photograph" size="28" color="#999"/>
						<span>点击上传</span>
					</div>
					<van-icon v-if="photoImage" name="clear" class="clear-icon" @click.stop="clearPhoto"/>
				</div>
				<div class="item-label">白底免冠照片</div>
			</div>
		</div>
	</div>
</template>

<script>
import H5Cropper from 'vue-cropper-h5'

export default {
	name: 'PhotoUploader',
	components: {
		H5Cropper
	},
	props: {
		title: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			photoImage: '',
			cropOptions: {
				fixedNumber: [3, 4],
				fixedBox: false,
				canMoveBox: true,
				outputType: 'jpeg',
				outputSize: 0.8
			}
		}
	},
	computed: {
		isComplete() {
			return !!this.photoImage
		}
	},
	methods: {
		handlePhotoCrop(data) {
			this.photoImage = data
			this.emitChange()
		},
		clearPhoto() {
			this.photoImage = ''
			this.emitChange()
		},
		emitChange() {
			this.$emit('change', {
				photo: this.photoImage,
				isComplete: this.isComplete
			})
			if (this.isComplete) {
				this.$emit('complete', {
					photo: this.photoImage
				})
			}
		},
		reset() {
			this.photoImage = ''
			this.emitChange()
		},
		getData() {
			return {
				photo: this.photoImage,
				isComplete: this.isComplete
			}
		}
	}
}
</script>

<style lang="less" scoped>
.photo-uploader {
	padding: 10px 0;
	
	.uploader-title {
		text-align: center;
		font-size: 14px;
		color: #666;
		margin-bottom: 15px;
	}
	
	.uploader-content {
		display: flex;
		justify-content: center;
		padding: 0 16px;
		
		.uploader-item {
			width: 50%;
			max-width: 200px;
			text-align: center;
			
			.cropper-box {
				width: 100%;
				height: 160px;
				position: relative;
				border-radius: 8px;
				overflow: hidden;
				border: 1px dashed #ddd;
				background-color: #fafafa;
				
				.preview-img {
					width: 100%;
					height: 100%;
					object-fit: cover;
					position: absolute;
					top: 0;
					left: 0;
				}
				
				.upload-tip {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					z-index: 1;
					pointer-events: none;
					
					span {
						font-size: 12px;
						color: #999;
						margin-top: 6px;
					}
				}
				
				.clear-icon {
					position: absolute;
					top: 5px;
					right: 5px;
					font-size: 18px;
					color: #fff;
					background: rgba(0,0,0,0.5);
					border-radius: 50%;
					padding: 3px;
					z-index: 10;
				}
				
				/deep/ .upbtn {
					width: 100%;
					height: 160px;
				}
			}
			
			.item-label {
				margin-top: 8px;
				font-size: 12px;
				color: #666;
			}
		}
	}
}
</style>
